import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d1608a62&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1608a62')) {
      api.createRecord('d1608a62', component.options)
    } else {
      api.reload('d1608a62', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d1608a62&", function () {
      api.rerender('d1608a62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/kol/follow-up/children/edit-kol/index.vue"
export default component.exports